var _g, _circle, _g2, _circle2, _g3, _g4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcTokenEnergy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_27418_115001)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    fill: "url(#paint0_linear_27418_115001)"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 5.9011,
    stroke: "url(#paint1_linear_27418_115001)",
    strokeWidth: 0.197802
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_iii_27418_115001)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6.00026,
    cy: 6.00015,
    r: 4.61538,
    fill: "url(#paint2_linear_27418_115001)"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.00026,
    cy: 6.00015,
    r: 4.61538,
    stroke: "url(#paint3_linear_27418_115001)",
    strokeWidth: 0.11988
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_dii_27418_115001)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_dii_27418_115001)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#stroke0_27418_115001",
    fill: "url(#paint4_linear_27418_115001)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "stroke1_27418_115001",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#stroke0_27418_115001"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.29788 5.61531C9.0185 5.61531 8.99994 5.60508 8.95377 5.34367C8.78466 4.38634 8.00596 3.86554 7.14398 3.70244C7.08135 3.6906 7.01683 3.68519 6.95421 3.67576C6.71762 3.63945 6.73934 3.51727 6.73998 3.47915C6.74124 3.41536 6.74588 3.34956 6.76317 3.28757C6.7948 3.17442 6.91056 3.18004 6.96306 3.18445C8.12868 3.28155 8.98666 3.77085 9.45244 4.83391C9.5176 4.98277 9.54733 5.14767 9.57748 5.30776C9.62893 5.5806 9.59224 5.61571 9.29768 5.61551L9.29788 5.61531Z",
    strokeWidth: 0.0675793,
    stroke: "url(#paint5_linear_27418_115001)",
    mask: "url(#stroke1_27418_115001)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_dii_27418_115001)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#stroke2_27418_115001",
    fill: "url(#paint6_linear_27418_115001)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "stroke3_27418_115001",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#stroke2_27418_115001"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.19122 5.61316C7.93039 5.61597 7.93945 5.61376 7.87451 5.37623C7.76697 4.98322 7.48084 4.75232 7.08359 4.63255C7.04626 4.62131 7.00683 4.6159 6.96846 4.60807C6.73841 4.56133 6.70404 4.518 6.72998 4.30514C6.74579 4.17535 6.81348 4.10373 6.96023 4.10052C7.52196 4.08808 7.93481 4.35369 8.24077 4.76335C8.37825 4.94731 8.46006 5.16679 8.51805 5.40452C8.54925 5.53311 8.48515 5.60373 8.33924 5.61256C8.29011 5.61556 8.24056 5.61296 8.19122 5.61296V5.61316Z",
    strokeWidth: 0.0675793,
    stroke: "url(#paint7_linear_27418_115001)",
    mask: "url(#stroke3_27418_115001)"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_dii_27418_115001)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#stroke4_27418_115001",
    fill: "url(#paint8_linear_27418_115001)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "stroke5_27418_115001",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#stroke4_27418_115001"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6.55639 4.89512C7.21511 5.1186 7.5645 5.46246 7.59149 6.12469C7.61068 6.59554 7.6033 7.07099 7.55417 7.53943C7.51115 7.94989 7.23704 8.25402 6.83746 8.40067C6.52139 8.51683 6.17875 8.60009 5.8418 8.62597C5.1913 8.67552 4.53448 8.69538 3.89179 8.54251C3.29949 8.40148 2.86301 8.09092 2.76644 7.48246C2.68125 6.94521 2.68083 6.40274 2.77698 5.8653C2.855 5.42835 3.13059 5.12061 3.55737 4.97075C3.85931 4.86483 4.48893 4.69169 5.02936 4.69189C5.68386 4.6921 6.14185 4.75449 6.55639 4.89512ZM5.99825 7.90375C6.33878 7.83173 6.4866 7.64435 6.49355 7.31133C6.50199 6.90609 6.50199 6.50024 6.49355 6.095C6.4866 5.75375 6.35544 5.58564 6.00563 5.49877C5.79583 5.44661 5.57295 5.41391 5.35724 5.41872C5.00385 5.42655 4.64497 5.443 4.30043 5.51041C3.97929 5.5732 3.84561 5.78043 3.84181 6.0944C3.83717 6.48881 3.83718 6.88322 3.8416 7.27763C3.84561 7.63874 3.99152 7.83012 4.35841 7.90676C4.62262 7.96193 5.72856 7.96092 5.99846 7.90375H5.99825Z",
    strokeWidth: 0.0675793,
    stroke: "url(#paint9_linear_27418_115001)",
    mask: "url(#stroke5_27418_115001)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_27418_115001",
    x: 0,
    y: -0.659341,
    width: 12,
    height: 13.0549,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.659341
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.527473
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.861685 0 0 0 0 0.44674 0 0 0 0.85 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_27418_115001"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.659341
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.197802
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_27418_115001",
    result: "effect2_innerShadow_27418_115001"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_iii_27418_115001",
    x: 1.32493,
    y: 0.245786,
    width: 9.35065,
    height: 11.6283,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1.07892
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.659341
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.660547 0 0 0 0 0.151367 0 0 0 0.9 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_27418_115001"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.31868
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.599401
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.576647 0 0 0 0 0.180608 0 0 0 0.75 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_27418_115001",
    result: "effect2_innerShadow_27418_115001"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.23976
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.17982
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.389179 0 0 0 0 0.102038 0 0 0 0 0.102038 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_27418_115001",
    result: "effect3_innerShadow_27418_115001"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_dii_27418_115001",
    x: 5.91167,
    y: 2.43925,
    width: 4.49623,
    height: 4.05501,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.0675793
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.405476
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.628681 0 0 0 0 0.367463 0 0 0 0 0.272474 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_27418_115001"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_27418_115001",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.675793
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.540634
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.899358 0 0 0 0 0.597431 0 0 0 0.85 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_27418_115001"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.675793
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.202738
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_27418_115001",
    result: "effect3_innerShadow_27418_115001"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_dii_27418_115001",
    x: 6.25967,
    y: 2.50682,
    width: 3.8168,
    height: 3.7083,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.11988
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.23976
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.628681 0 0 0 0 0.367463 0 0 0 0 0.272474 0 0 0 0.45 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_27418_115001"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_27418_115001",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.675793
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.540634
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.899358 0 0 0 0 0.597431 0 0 0 0.85 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_27418_115001"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.675793
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.202738
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_27418_115001",
    result: "effect3_innerShadow_27418_115001"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_dii_27418_115001",
    x: 6.2431,
    y: 3.42431,
    width: 2.76219,
    height: 2.78887,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.11988
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.23976
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.628681 0 0 0 0 0.367463 0 0 0 0 0.272474 0 0 0 0.45 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_27418_115001"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_27418_115001",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.675793
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.540634
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.899358 0 0 0 0 0.597431 0 0 0 0.85 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_27418_115001"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.675793
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.202738
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_27418_115001",
    result: "effect3_innerShadow_27418_115001"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_dii_27418_115001",
    x: 2.22414,
    y: 4.0161,
    width: 5.85664,
    height: 5.24541,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.11988
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.23976
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.628681 0 0 0 0 0.367463 0 0 0 0 0.272474 0 0 0 0.45 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_27418_115001"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_27418_115001",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.675793
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.540634
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.899358 0 0 0 0 0.597431 0 0 0 0.85 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_27418_115001"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.675793
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.202738
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_27418_115001",
    result: "effect3_innerShadow_27418_115001"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_27418_115001",
    x1: 2.17582,
    y1: 0.857143,
    x2: -1.01696,
    y2: 10.6646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.371592,
    stopColor: "#FFDA83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.569781,
    stopColor: "#FFE2A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECC068"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_27418_115001",
    x1: 6,
    y1: 0,
    x2: 6,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE4AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC86A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_27418_115001",
    x1: 4.49842,
    y1: 2.154,
    x2: 3.21781,
    y2: 9.94768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7BB55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.561619,
    stopColor: "#FFC165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECC068"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_27418_115001",
    x1: 4.08217,
    y1: 2.22393,
    x2: 6.86939,
    y2: 10.4957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEBBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDA000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_27418_115001",
    x1: 7.25736,
    y1: 3.3564,
    x2: 6.43881,
    y2: 5.69328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.377919,
    stopColor: "#FFEBC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_27418_115001",
    x1: 8.16807,
    y1: 3.18262,
    x2: 8.16807,
    y2: 5.61551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE4AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC86A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_27418_115001",
    x1: 7.04957,
    y1: 4.20823,
    x2: 6.54573,
    y2: 5.66676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.377919,
    stopColor: "#FFEBC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_27418_115001",
    x1: 7.6242,
    y1: 4.1001,
    x2: 7.6242,
    y2: 5.61401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE4AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC86A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_27418_115001",
    x1: 3.59168,
    y1: 4.97548,
    x2: 2.30665,
    y2: 8.82828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.377919,
    stopColor: "#FFEBC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_27418_115001",
    x1: 5.15246,
    y1: 4.69189,
    x2: 5.15246,
    y2: 8.66209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE4AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC86A"
  })), /*#__PURE__*/React.createElement("path", {
    id: "stroke0_27418_115001",
    d: "M9.29788 5.61531C9.0185 5.61531 8.99994 5.60508 8.95377 5.34367C8.78466 4.38634 8.00596 3.86554 7.14398 3.70244C7.08135 3.6906 7.01683 3.68519 6.95421 3.67576C6.71762 3.63945 6.73934 3.51727 6.73998 3.47915C6.74124 3.41536 6.74588 3.34956 6.76317 3.28757C6.7948 3.17442 6.91056 3.18004 6.96306 3.18445C8.12868 3.28155 8.98666 3.77085 9.45244 4.83391C9.5176 4.98277 9.54733 5.14767 9.57748 5.30776C9.62893 5.5806 9.59224 5.61571 9.29768 5.61551L9.29788 5.61531Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "stroke2_27418_115001",
    d: "M8.19122 5.61316C7.93039 5.61597 7.93945 5.61376 7.87451 5.37623C7.76697 4.98322 7.48084 4.75232 7.08359 4.63255C7.04626 4.62131 7.00683 4.6159 6.96846 4.60807C6.73841 4.56133 6.70404 4.518 6.72998 4.30514C6.74579 4.17535 6.81348 4.10373 6.96023 4.10052C7.52196 4.08808 7.93481 4.35369 8.24077 4.76335C8.37825 4.94731 8.46006 5.16679 8.51805 5.40452C8.54925 5.53311 8.48515 5.60373 8.33924 5.61256C8.29011 5.61556 8.24056 5.61296 8.19122 5.61296V5.61316Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "stroke4_27418_115001",
    d: "M6.55639 4.89512C7.21511 5.1186 7.5645 5.46246 7.59149 6.12469C7.61068 6.59554 7.6033 7.07099 7.55417 7.53943C7.51115 7.94989 7.23704 8.25402 6.83746 8.40067C6.52139 8.51683 6.17875 8.60009 5.8418 8.62597C5.1913 8.67552 4.53448 8.69538 3.89179 8.54251C3.29949 8.40148 2.86301 8.09092 2.76644 7.48246C2.68125 6.94521 2.68083 6.40274 2.77698 5.8653C2.855 5.42835 3.13059 5.12061 3.55737 4.97075C3.85931 4.86483 4.48893 4.69169 5.02936 4.69189C5.68386 4.6921 6.14185 4.75449 6.55639 4.89512ZM5.99825 7.90375C6.33878 7.83173 6.4866 7.64435 6.49355 7.31133C6.50199 6.90609 6.50199 6.50024 6.49355 6.095C6.4866 5.75375 6.35544 5.58564 6.00563 5.49877C5.79583 5.44661 5.57295 5.41391 5.35724 5.41872C5.00385 5.42655 4.64497 5.443 4.30043 5.51041C3.97929 5.5732 3.84561 5.78043 3.84181 6.0944C3.83717 6.48881 3.83718 6.88322 3.8416 7.27763C3.84561 7.63874 3.99152 7.83012 4.35841 7.90676C4.62262 7.96193 5.72856 7.96092 5.99846 7.90375H5.99825Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTokenEnergy);
export default __webpack_public_path__ + "static/media/ic-token-energy.a4cd3dc0402724e08357e99ad425efdd.svg";
export { ForwardRef as ReactComponent };